import { Component } from '@angular/core';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {WidgetSetupThermostatComponent} from './widget.setup.thermostat.component';
import {WidgetSetupSwitchComponent} from './widget.setup.switch.component';
import {WidgetSetupTemperatureComponent} from './widget.setup.temperature.component';
import {WidgetSetupEnergyComponent} from './widget.setup.energy.component';
import {WidgetSetupTemperaturechartComponent} from './widget.setup.temperaturechart.component';
import {WidgetSetupElectricitychartComponent} from './widget.setup.electricitychart.component';

@Component({
  selector: 'ngx-modal',
  templateUrl: './widget.list.component.html',
  styleUrls: ['./widget.list.component.scss'],
})

export class WidgetListComponent {

    thConfig = {
        name: 'Thermostat',
    };

  constructor(private activeModal: NgbActiveModal,
              private modalService: NgbModal) {
  }

  addWidget(widget) {

      this.activeModal.close();

      let wg = null;

      if (widget === 'WidgetSetupThermostatComponent') {
          wg = WidgetSetupThermostatComponent;
      }else if (widget === 'WidgetSetupSwitchComponent') {
          wg = WidgetSetupSwitchComponent
      }else if (widget === 'WidgetSetupTemperatureComponent') {
          wg = WidgetSetupTemperatureComponent
      }else if (widget === 'WidgetSetupEnergyComponent') {
          wg = WidgetSetupEnergyComponent
      }else if (widget === 'WidgetSetupTemperaturechartComponent') {
          wg = WidgetSetupTemperaturechartComponent
      }else if (widget === 'WidgetSetupElectricitychartComponent') {
          wg = WidgetSetupElectricitychartComponent
      }else
      {
          console.log('Unsupported choice of widget: ' + widget);
          return;
      }

      this.modalService.open(wg, {
          size: 'lg',
          backdrop: 'static',
          container: 'nb-layout',
      });
  }


  closeModal() {
    this.activeModal.close();
  }

}



// WEBPACK FOOTER //
// /app/src/app/@core/component/add-widget/modal/widget.list.component.ts